module.exports = __webpack_public_path__ + "static/media/day-4.78f53a11.jpg";